import cheader from '@/components/header/index.vue'

export default {
	name: 'shopping',
	data() {
		return {
			shoppings: [],
			detailShow: false,
			details: [],
			page:1,
			pageTotal:0,
			pageSize:10,
			search:"",
			loading:true
		}
	},
	components: {
		cheader
	},
	computed: {
		user() {
			return this.$store.state.user
		}
	},
	created() {
		this.index()
	},
	methods: {
		go(url) {
			this.$router.push(url)
		},
		index() {
			let url = this.$route.params.type == 'erp' ? '/api/inquiry/procurementPlan' : '/api/inquiry/myInquiry'
			var params = {
				userId: this.user.id,
				page:this.page,
				pageSize:this.pageSize
			}
			params.name = this.search
			this.$http.get(url,{params: params}).then((res) => {
				this.loading=false
				this.shoppings = res.data.data
				this.pageTotal = res.data.total
			})
		},
		handleSizeChange(val){
			this.pageSize = val;
			this.index();
		},
		// 分页导航
		handlePageChange(val) {
			this.page = val
			this.index();
		},
		show(id) {
			this.detailShow = true
			let url = this.$route.params.type == 'erp' ? '/api/inquiry/procurementPlanInfo' : '/api/inquiry/myInquiryInfo'
			this.$http.get(url, {params: {id: id}}).then((res) => {				
				this.details = this.$route.params.type == 'erp' ? res.data.data : res.data.data.productList
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/home/inquiry/shopping/index.js